import React, { useEffect, useState } from "react";
import WidgetLoading from "../../../widget/WidgetLoading";
import Config from "../../../config/Config";
import Map from "../../com/map";
import { EnvironmentOutlined } from '@ant-design/icons';
import { Image, Space, Typography, Divider, Skeleton } from 'antd';
import WidgetAjax from "../../../widget/WidgetAjax";
import DetailHead from "../Detail_head";
import EnterpriseIcon from '../../enterprise/com/icon/enterpriseIcon';
import NoData from "../NoData";

import './index.scss';
const path = Config.getBasePath();
const filePath = Config.getFilePath();

// 基本概况展示信息列表
const baseInfoList = [
    { label: "经验要求", props: "REQWE_CN" },
    { label: "年龄要求", props: "REQAGE", type: "REQAGE" },
    { label: "学历要求", props: "REQEDU_CN" },
    { label: "性别要求", props: "REQSEX_CN" },
    { label: "到岗时间", props: "REQST_CN" },
    { label: "招聘人数", props: "HEADCOUNT", unit: "人" },
    { label: "工作性质", props: "PROPERTY_CN" },
    { label: "招聘形式", props: "" },
    { label: "岗位班制", props: "SHIFT_CN" },
    { label: "上班时间", props: "SCHEDULE" },
];
// 内容标题
const contentTitle = {
    baseInfo: "基本概况",
    socialBenefits: "福利待遇",
    jobDetail: "岗位详情",
    AIsuggest: "AI投递建议",
    progress: "入职流程",
    environment: "岗位环境",
    enterpriseInfo: "企业信息",
    address: "工作地址",
};
// 内容及顺序
const content = [
    "baseInfo",  // 基本概况
    "socialBenefits",  // 福利待遇
    "jobDetail", // 岗位详情
    "AIsuggest", // AI投递建议
    "progress", // 入职流程
    "environment", // 岗位环境
    "enterpriseInfo", // 企业信息
    "address", // 工作地址
]
const DetailInfo = ({
    infoLoading = false, // 页面loading加载
    info = {}, // info岗位信息
    contentList = content, // 内容模块分布及顺序
    entInfo = {}, // 企业信息
    reloadInfo = () => { }, // 重新加载信息
    isHeader = true, // 是否展示头部
    history,
    headerOperation = undefined,
}) => {
    const [environmentList, setEnvironmentList] = useState([]);
    const [environmentLoading, setEnvironmentLoading] = useState(false);
    // 处理信息展示
    const setDealWithValue = (data) => {
        switch (data.type) {
            case 'num':
                return info[data.props] || 0
            default:
                return data.props && data.props !== '' ? (info[data.props] ?? '-') : '-'
        }
    };
    // 获取岗位环境图片
    const environment = (id) => {
        WidgetAjax.ajax({
            url: path + "/job/environment_list",
            params: { job_id: info.id },
            callback: (res) => {
                setEnvironmentLoading(false);
                setEnvironmentList(res.results)
            },
        });
    };

    const handleReloadInfo = () => {
        if (reloadInfo) {
            reloadInfo()
        }
    }

    useEffect(() => {
        if (info.id) {
            setEnvironmentLoading(true);
            environment()
        }
    }, [info])
    
    return (
        <div className="componet-detail-wrap" component-data={Config.getSourcePath()}>
            <WidgetLoading loading={infoLoading}>
                
                {
                    infoLoading
                    ?   <>
                            <Skeleton active paragraph={{ rows: 4 }} />
                            <Skeleton active paragraph={{ rows: 4 }} />
                            <Skeleton active paragraph={{ rows: 5 }} />
                        </>
                    :   <>
                            {
                                info && JSON.stringify(info) !== '{}'
                                ?   <>
                                        {
                                            isHeader
                                                ? <DetailHead info={info} reloadInfo={handleReloadInfo} history={history} headerOperation={headerOperation} />
                                                : <></>
                                        }

                                        <div className="componet-detail-job-info-content">
                                            {
                                                contentList.map((item, index) => {
                                                    return <div
                                                        key={index}
                                                        className="componet-detail-job-modal"
                                                    >
                                                        <div className="componet-detail-job-modal-title">{contentTitle[item]} </div>
                                                        {
                                                            item == 'baseInfo'
                                                                ? <div className="componet-detail-job-baseInfo-wrap">
                                                                    {
                                                                        baseInfoList
                                                                            ? baseInfoList.map((listItem, listIndex) => {
                                                                                return <div key={listIndex} className="componet-detail-job-baseInfo-item" style={{width: listItem.props === 'SCHEDULE' ? '50%' : '' }}>
                                                                                    <label>{listItem.label}</label>
                                                                                    <span>{setDealWithValue(listItem)}{listItem.unit}</span>
                                                                                </div>
                                                                            })
                                                                            : <></>
                                                                    }
                                                                </div>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'socialBenefits'
                                                                ? <div className="componet-detail-job-tag">
                                                                    {
                                                                        info.WELFARE && info.WELFARE.length > 0
                                                                            ? info.WELFARE.map((citem, cindex) => {
                                                                                return <div key={cindex} className="componet-detail-job-tag-item">{citem}</div>
                                                                            })
                                                                            : <div className="componet-detail-job-nodata">暂无福利信息</div>
                                                                    }
                                                                </div>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'jobDetail'
                                                                ? <>
                                                                    {
                                                                        info.DETAIL && info.DETAIL !== ''
                                                                            ? <div dangerouslySetInnerHTML={{ __html: info.DETAIL }} className="componet-detail-job-article"></div>
                                                                            : <div className="componet-detail-job-nodata">暂无岗位信息</div>
                                                                    }
                                                                </>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'AIsuggest'
                                                                ? <div className="componet-detail-job-article">
                                                                    <div className="componet-detail-job-nodata">暂无投递建议</div>
                                                                </div>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'progress'
                                                                ? <div>
                                                                    <img src={require("../../../img/pinzhunzhun/job_info/flowChart.svg")} />
                                                                </div>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'enterpriseInfo'
                                                                ? <div className="componet-detail-job-enterpriseInfo">
                                                                    {
                                                                        entInfo ?
                                                                            <div className="company-header">
                                                                                {
                                                                                    entInfo?.LOGO || entInfo.ENTLOGO
                                                                                        ? <img class="sg-ENTImg" src={filePath + 'enterprise/M' + entInfo?.id + '.png'} />
                                                                                        : <EnterpriseIcon width="26px" size="18px" />
                                                                                }

                                                                                <div className='company-infos'>
                                                                                    <div className='company-name'>{entInfo?.ENTNAME}</div>

                                                                                    <div className='company-type'>
                                                                                        <Space split={<Divider type="vertical" />}>
                                                                                            {
                                                                                                entInfo.INDTYPE_CN && entInfo.INDTYPE_CN !== ''
                                                                                                    ? <Typography.Text>{entInfo.INDTYPE_CN}</Typography.Text>
                                                                                                    : <></>
                                                                                            }
                                                                                            {
                                                                                                entInfo.SCALE_CN && entInfo.SCALE_CN !== ''
                                                                                                    ? <Typography.Text>{entInfo.SCALE_CN + '-' + entInfo.SCALE_CN}</Typography.Text>
                                                                                                    : <></>
                                                                                            }
                                                                                            {
                                                                                                entInfo.ENTTYPE_CN && entInfo.ENTTYPE_CN !== ''
                                                                                                    ? <Typography.Text>{item.ENTTYPE_CN}</Typography.Text>
                                                                                                    : <></>
                                                                                            }
                                                                                        </Space>
                                                                                    </div>
                                                                                </div>
                                                                            </div> : null
                                                                    }
                                                                    {
                                                                        entInfo?.PROFILE ? <p className='introduce'>公司介绍：{entInfo?.PROFILE}</p> : null
                                                                    }
                                                                    {
                                                                        entInfo?.MBSCOPE ? <p className='introduce'>主要经营业务：{entInfo?.MBSCOPE}</p> : null
                                                                    }
                                                                </div>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'environment'
                                                                ? <WidgetLoading loading={environmentLoading}>
                                                                    <div className="componet-detail-job-environment">

                                                                        {
                                                                            environmentList && environmentList.length > 0 ?
                                                                                environmentList.map((imageItem) => {
                                                                                    return <div style={{ marginRight: '16px', marginBottom: '16px' }}>
                                                                                        <Image src={filePath + "job/F" + imageItem.id + (imageItem.TYPE == 1 ? '.png' : '')} /> </div>
                                                                                })
                                                                                : '暂无环境照片'
                                                                        }
                                                                    </div>
                                                                </WidgetLoading>
                                                                : <></>
                                                        }
                                                        {
                                                            item == 'address'
                                                                ? <div>
                                                                    {
                                                                        info.ADDRESS
                                                                            ? <p className="componet-detail-job-article componet-detail-job-address-text">
                                                                                <EnvironmentOutlined style={{ marginRight: "10px" }} />
                                                                                {info.ADDRESS}
                                                                            </p>
                                                                            : <></>
                                                                    }


                                                                    {
                                                                        info.LOCATION && info.LOCATION.DISTRICT
                                                                            ? <div style={{ height: "300px" }}> <Map lat={info.LOCATION.DISTRICT.LAT} lng={info.LOCATION.DISTRICT.LNG} /></div>
                                                                            : <></>
                                                                    }


                                                                </div>
                                                                : <></>
                                                        }
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </>
                                :   <NoData width={'300px'} height={'300px'}/>
                            }
                        </>
                }
                
            </WidgetLoading>
        </div>
    )
}

export default DetailInfo;